module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down.73175664.svg";